import { Component, OnInit, Input } from '@angular/core';
import { NodeConnectionUi } from "classes/NodeConnectionUi";
import { NodeConnectionNames } from "dto/NodeConnection";
import { MetaDataDto } from "dto/MetadataDto";

@Component({
  selector: 'connection',
  templateUrl: './connection.component.html',
  styleUrls: ['./connection.component.css']
})
export class ConnectionComponent implements OnInit {

  @Input() connection: NodeConnectionUi;
  constructor() { }

  ngOnInit() {
  }

    dropOnConnectionPoint($event:any, connectionPoint:NodeConnectionUi):void {
        
        if($event.dragData.NodeType !== undefined) //a template is dropped on the connection point
            this.connection.From.Flow.addNewNode(connectionPoint,$event.dragData);
        else //an existing node is dropped on the connection point
            this.connection.From.Flow.MoveToConnectionPoint($event.dragData, connectionPoint);
        
        this.connection.From.Flow.Refresh();
        
    }

    addNewNodeAt(event:any, connectionPoint:NodeConnectionUi){
        //add a new childnode to this node triggered by the result of the given value.
        event.stopPropagation();
        this.connection.From.Flow.addNewNode(connectionPoint);
        this.connection.From.Flow.ReRender();
        this.connection.From.Flow.Save();
    }

    mouseOverConnection(connection:NodeConnectionUi){
        if(connection.Dto.Name != NodeConnectionNames.ALWAYS_TRIGGERED)
        connection.From.Highlight = true;
    }

    mouseOutConnection(connection:NodeConnectionUi){
        connection.From.Highlight = false;
    }
}



// WEBPACK FOOTER //
// C:/git/flowdesigner/src/app/connection/connection.component.ts